import { useState, useEffect } from 'react';
import { getTests, getTestById } from '../services/test.service.ts';

export const useTestData = (instance, setPendingApiCalls, testId = null) => {
  const [testData, setTestData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Não carregar se não houver testId válido
    if (!testId || testId === 'undefined') {
      setLoading(false);
      return;
    }

    const loadTestData = async () => {
      try {
        setLoading(true);
        setPendingApiCalls((current) => current.concat(['getTests']));

        // Se temos um ID específico, buscar apenas esse teste
        const data = await getTestById(instance, testId);
        setTestData(data);
      } catch (err) {
        setError(err.message || 'Failed to load test data');
      } finally {
        setLoading(false);
        setPendingApiCalls((current) => current.filter((item) => item !== 'getTests'));
      }
    };

    loadTestData();
  }, [instance, setPendingApiCalls, testId]);

  return { testData, loading, error };
};